function toggleInventoryVisibility() {
  const inventoryWrapper = document.querySelector('.product__inventory');
  const inventoryText = document.querySelector('.product__inventory-inner');

  if (!inventoryWrapper || !inventoryText) return;

  const text = inventoryText.textContent.toLowerCase();

  if (text.includes('out of stock')) {
    inventoryWrapper.style.display = 'block';
  } else {
    inventoryWrapper.style.display = 'none';
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  toggleInventoryVisibility();
});

// Handle variant change (important for Shopify)
document.addEventListener('change', function (e) {
  if (e.target.closest('form[action*="/cart/add"]')) {
    setTimeout(toggleInventoryVisibility, 300);
  }
});